import { clearPwaCaches } from '@/shared/lib/clearPwaCaches'
import { useToastStore } from '@/shared/ui/toast/toastStore'
import { applyPwaUpdate } from '@/shared/pwa/applyPwaUpdate'

/**
 * Indica que já houve um recarregamento automático nesta sessão para recuperar chunk obsoleto.
 * Quando ainda `1`, a próxima falha de chunk mostra toast em vez de novo reload (evita loop).
 */
export const SYNAP_STALE_CHUNK_RELOAD_KEY = 'synap_stale_chunk_auto_reload'

let recoveryInFlight = false

export function isChunkLoadError(err: unknown): boolean {
  if (err instanceof Error && err.name === 'ChunkLoadError') return true
  const msg = err instanceof Error ? err.message : String(err ?? '')
  return (
    /failed to fetch dynamically imported module/i.test(msg) ||
    /loading chunk \d+ failed/i.test(msg) ||
    /chunkloaderror/i.test(msg) ||
    /importing a module script failed/i.test(msg)
  )
}

export function clearStaleChunkReloadAttempt(): void {
  try {
    sessionStorage.removeItem(SYNAP_STALE_CHUNK_RELOAD_KEY)
  } catch {
    /* ignore */
  }
}

/**
 * Primeira falha de chunk nesta sessão (após alinhar versão com `version.json`): limpa caches e recarrega.
 * Se já recarregou uma vez e o chunk continua falhando: toast com «Atualizar» (`applyPwaUpdate`).
 */
export function recoverFromStaleDeployment(): void {
  if (recoveryInFlight) return
  recoveryInFlight = true

  try {
    let attempted: string | null = null
    try {
      attempted = sessionStorage.getItem(SYNAP_STALE_CHUNK_RELOAD_KEY)
    } catch {
      window.location.reload()
      return
    }

    if (attempted === '1') {
      recoveryInFlight = false
      useToastStore.getState().add(
        'Nova versão disponível. Toque em Atualizar para recarregar o aplicativo.',
        {
          variant: 'info',
          durationMs: 0,
          tapToAction: true,
          action: {
            label: 'Atualizar',
            style: 'primary',
            onClick: () => {
              void applyPwaUpdate()
            },
          },
        },
      )
      return
    }

    try {
      sessionStorage.setItem(SYNAP_STALE_CHUNK_RELOAD_KEY, '1')
    } catch {
      window.location.reload()
      return
    }

    void clearPwaCaches().then(() => {
      window.location.reload()
    })
  } catch {
    window.location.reload()
  }
}
